<template>
  <div>
  <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#3F033B"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#3F033B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs3 pa-1>
        <v-card outlined height="100%">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/building.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font7">{{ DataList.assemblyname }}</span><br/>
              <span class="font5">Constituency</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/addVoters')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/multiple-users-silhouette.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.totalVoters }}</span><br/>
              <span class="font5">Total Voters</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/addVoters?gender='+'Male')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/man.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.totalMaleVoters }}</span><br/>
              <span class="font5">Male Voters</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex> 
      <v-flex xs3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/addVoters?gender='+'Female')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/girl.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.totalFemaleVoters }}</span><br/>
              <span class="font5">Female Voters</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/addBooth')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/voting-booth.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.totalBooths }}</span><br/>
              <span class="font5">Total Booth</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
     
      <v-flex xs3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/addVoters?id='+'1')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/group.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.voterAgebetween }}</span><br/>
              <span class="font5">Voters between 18-35 age</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/addVoters?id='+'2')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/addfriend.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.voterAgeAbove35 }}</span><br/>
              <span class="font5">Voters above 35 age</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs3 pa-1>
        <v-card outlined height="100%" @click="$router.push('/addVoters?id='+'3')">
          <v-layout wrap pa-4 fill-height>
            <v-flex xs2 align-self-center>
             <v-img height="60px" contain src="./../../assets/icons/old-man.png"></v-img>
            </v-flex>
            <v-flex xs10 align-self-center text-right>
              <span class="font4">{{ DataList.ageelderCount }}</span><br/>
              <span class="font5">senior citizen Voters <br/>(60+ age)</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
</v-layout>
    <!-- <v-layout justify-space-between wrap pt-1>
      <v-flex xs3 pa-2 align-self-center v-for="(value, i) in CountList" :key="i" >
        <v-card elevation="2" class="pa-4 bluegrad" data-aos="fade-up" 
     data-aos-duration="1200">
          <v-layout justify-center py-2 wrap>
            <v-flex xs12 py-1 class="font1">{{ value.name }} :</v-flex>
            <v-flex xs12 py-1 class="font2">{{ value.count }}</v-flex>
            <v-flex xs12 py-1 class="font1">({{ value.voters }} Voters)</v-flex>
            <v-flex xs12 sm10  py-1>
              <v-btn small  block color="white" @click="checkLevel(value.name)" class="buttons1">
          <v-icon small>mdi-plus</v-icon> &nbsp; Add {{ value.name }}
        </v-btn>
            </v-flex>
            

            <v-flex xs12 sm10  py-1>
              <v-btn small dark block color="#197eb6" @click="checkUser2(value.name)" class="buttons1">
          <v-icon small>mdi-plus</v-icon> &nbsp; Add Users
        </v-btn>
            </v-flex>
          
          </v-layout>
        </v-card>
        </v-flex>
    </v-layout> -->
    <!----------------------------------------GRAPH------------------------------------------>
    <v-layout wrap>
      <v-flex xs12 sm6 pa-4>
        <chart3/>
</v-flex>
      <v-flex xs12 sm6 pa-4>
        <chart2/>
</v-flex>
    </v-layout>
    <!------------------------------------------------------------------------------------>
    <v-dialog width="800px" v-model="addUser">
          <v-form v-model="addcat2" ref="addcat2" @submit.prevent>
            <v-card tile width="800px" class="rounded-lg px-4">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center
                  ><span style="color: #182444" class="menuhead1"
                    >Add User</span
                  ></v-flex
                >
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(addUser = false),(resetForm2())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-2>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> First Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="[rules.required]"
                        type="text"
                        label="First Name"
                        v-model="firstname"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Last Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="text"
                        label="Last Name"
                        v-model="lastname"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Mobile Number </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Contact"
                        v-model="phone"
                        outlined
                        color="#50659f"
                        :rules="phoneRules"
                        dense
                        type="number"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Email Address </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        :rules="[rules.email]"
                        type="email"
                        label="Enter Email"
                        v-model="email"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Location</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="LocationList"
                        v-model="location"
                        label="Select Location"
                        item-text="name"
                        item-value="_id"
                        outlined
                        hide-details
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
             
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Role</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="rolesList"
                        v-model="mainRole"
                        label="Select Role"
                        item-text="roles"
                        item-value="_id" 
                        outlined
                        hide-details
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Gender</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#50659f"
                        v-model="gender"
                        :items="genderList"
                        label="Choose Gender"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="AddUser()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="500px" v-model="addConstituencyDialog">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card tile width="500px" class="rounded-lg">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Add Constituency</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(addConstituencyDialog = false)(resetForm())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap pb-4>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Constituency Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                        type="text"
                        label="Constituency"
                        v-model="newConstituency"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                   
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="AddConstituency()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="500px" v-model="addPanchayatDialog">
          <v-form v-model="addcat3" ref="addcat" @submit.prevent>
            <v-card tile width="500px" class="rounded-lg">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Add Panchayat</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(addPanchayatDialog = false)(resetForm3())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap pb-4>
                    <v-flex xs12 pb-2>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Panchayat Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                        type="text"
                        label="Panchayat"
                        v-model="newPanchayat"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                      <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Constituency</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                        :items="LocationList"
                        v-model="constituency"
                        label="Select Constituency"
                        item-text="name"
                        item-value="_id"
                        outlined
                        hide-details
                        dense
                      ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex> 
                   
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="AddPanchayat()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="500px" v-model="addWardDialog">
          <v-form v-model="addcat4" ref="addcat" @submit.prevent>
            <v-card tile width="500px" class="rounded-lg">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Add ward</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(addWardDialog = false)(resetForm4())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center pt-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 pb-2>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Ward Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                        type="text"
                        label="Ward"
                        v-model="newWard"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                    <v-flex xs12 pb-2>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Panchayat</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                        :items="panchayatList"
                        v-model="panchayat"
                        label="Select Panchayat"
                        item-text="name"
                        item-value="_id"
                        outlined
                        hide-details
                        dense
                      ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex> 
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="AddWard()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="500px" v-model="addBoothDialog">
          <v-form v-model="addcat5" ref="addcat" @submit.prevent>
            <v-card tile width="500px" class="rounded-lg">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Add booth</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(addBoothDialog = false),(resetForm5())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center pt-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 pb-2>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">booth Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                        type="text"
                        label="booth"
                        v-model="newbooth"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                   
                  </v-layout>
                </v-flex>
                    <v-flex xs12 pb-2>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Ward</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                        :items="wardList"
                        v-model="Newward"
                        label="Select Ward"
                        item-text="name"
                        item-value="_id"
                        outlined
                        hide-details
                        dense
                      ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex> 
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="Addbooth()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
  
  </div>
</template>
<script>
import axios from "axios";
// import AccountMenu2 from "./../../components/accountMenu2";
import chart2 from "./chart2";
import chart3 from "./chart3";
// import store from "./../../store";
export default {
  components: {
    chart2,
    chart3,
  //   AccountMenu2,
  },
  data() {
    return {
      gradientTextStyle: {
        // Define the linear gradient as font color using background-clip
        backgroundClip: "text",
        backgroundImage: "linear-gradient(36deg, rgba(24,36,68,1) 3%, rgba(0,85,135,1) 52%, rgba(0,99,161,1) 95%)", // Replace with your desired gradient
        WebkitBackgroundClip: "text", // For Safari support
        color: "transparent",
        WebkitTextFillColor: "transparent", // For Safari support
      },
      addcat:false,
      addcat2:false,
      addcat3:false,
      addcat4:false,
      addcat5:false,
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      addUser:false,
      firstname:"",
      lastname:"",
      phone:"",
      email:"",
      gender:"",
      mainRole:"",
      rolesList:[],
      genderList: ["Male", "Female", "Other"],
      myLevel:"",

      addId:"",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phoneRules: [
        (v) => !!v || "phone is required",
        (v) => (v && v.length <= 10) || "invalid number",
        (v) => (v && v.length >= 10) || "invalid number",
        (v) => /^\d{10}$/.test(v) || "phone number must be a number",
      ],

      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
// GRAPH
      series: [70, 20, 10],
      chartOptions: {
        colors: ["#D61A3C", "#0E26B1", "#FFA500", "rgb(0, 77, 26)"],
        fill: {
          colors: ["#D61A3C", "#0E26B1", "#FFA500", "rgb(0, 77, 26)"],
        },
        chart: {
          width: 380,
          type: "pie",
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
            },
            autoSelected: "zoom",
          },
        },
        labels: [
          "Voters in favour",
          " Voters not in favour",
          "Undecided voters",
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
//add constituency
newConstituency:"",
addConstituencyDialog:false,
//addpanchayat
addPanchayatDialog:false,
newPanchayat:"",
constituency:"",
//ward
addWardDialog:false,
newWard:"",
panchayat:"",
//Booth
addBoothDialog:false,
newbooth:"",
Newward:"",
//
CountList:[],
panchayatList:[],
wardList:[],
boothList:[],
DataList:[],
LocationList:[],
newName:"",
location:"",
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
 
    mounted() {
    this.getCount();
    this.getUsera();
    this.getData();
    },
    methods: {
      resetForm() {
      this.$refs.addcat.reset();
    },
    resetForm2() {
      this.$refs.addcat2.reset();
    },
    resetForm3() {
      this.$refs.addcat3.reset();
    },
    resetForm4() {
      this.$refs.addcat4.reset();
    },
    resetForm5() {
      this.$refs.addcat5.reset();
    },
      checkUser(selectedRoleId) {
    const selectedRole = this.rolesList.find(role => role._id === selectedRoleId);
    if (selectedRole) {
      const selectedName = selectedRole.roles;
      console.log("selectedName=",selectedName)
    } else {
      // Handle the case where the selected role is not found in rolesList.
    }
  },
      checkUser2(name){
        console.log("12345");
        console.log("name=",name);
        if(name== 'Constituencies'){
          this.myLevel = "LoksabhaConstituency";
          console.log("level=",this.myLevel)
          this.getConstituency();
        }
        else if(name== 'Panchayat'){
          this.myLevel = "Panchayat";
          console.log("level=",this.myLevel)
          this.getPanchayat();
        }
        else if(name== 'Ward'){
          this.myLevel = "Ward";
          console.log("level=",this.myLevel)
          this.getWard();
        }
        else if(name== 'Booth'){
          this.myLevel = "Booth";
          console.log("level=",this.myLevel)
          this.getbooth();
        }
    this.getRole(this.myLevel);
        this.addUser = true
      },
      checkLevel(name){
        console.log("#####");

        console.log("name=",name)
        if(name== 'Constituencies'){
          this.addConstituencyDialog = true;
        }
        else if(name== 'Panchayat'){
          this.addPanchayatDialog = true;
          this.getConstituency();
        }
        else if(name== 'Ward'){
          this.addWardDialog = true;
          this.getPanchayat();
        }
        else if(name== 'Booth'){
          this.addBoothDialog = true;
          this.getWard();
        }
    // this.getRole(this.myLevel);
      },
      getCount() {
      this.appLoading = true;
      axios({
        url: "/dashboard/count",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   page: this.page,
        //   limit: 50,

        // },
      })
        .then((response) => {
          this.appLoading = false;
          this.CountList = response.data.countList;
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/candidate/dashboard/count",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.appLoading = false;
          this.DataList = response.data.data;
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getUsera() {
      this.appLoading = true;
      axios({
        url: "/user/getlist",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.appLoading = false;
          this.CountList = response.data.countList;
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    AddUser() {
      // this.appLoading = true;
      axios({
        url: "/candidate/add/user",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          electionType: this.userData.electionType._id,
          firstname : this.firstname,
          lastname : this.lastname,
          phone : this.phone,
          email : this.email,
          gender : this.gender,
          mainRole : this.mainRole,
          assignField : this.location,
          level:this.myLevel,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.showSnackBar = true;
          this.adddialog = false;
          this.msg = response.data.msg;
          this.firstname = "";
          this.lastname = "";
          this.phone = "";
          this.email = "";
          this.gender = "";
          this.addId = "";
          this.mainRole = "";
          this.location = "";
          this.myLevel = "";
          this.appLoading = false;
          this.addUser = false;
          location.reload();
          // this.getUsera();
      this.$refs.addcat2.reset();
    } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getRole(level) {
      // console.log("role=",this.role)
      this.appLoading = true;
      axios({
        url: "/getalllist/user/roles",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          level : level,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.appLoading = false;
          this.rolesList = response.data.data;
          this.Pagelength = Math.ceil(response.data.count / 50);
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getPanchayat() {
      axios({
        url: "/panchayat/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // constituencyId:constituency,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.appLoading = false;
          this.panchayatList = response.data.data;
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getWard() {
      // console.log("role=",this.role)
      this.appLoading = true;
      axios({
        url: "/ward/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // panchayatId: panchayat,

        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.appLoading = false;
          this.wardList = response.data.data;
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getbooth() {
      this.appLoading = true;
      axios({
        url: "/booth/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          limit: 50,
          wardId: this.wardFilter,

        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.appLoading = false;
          this.LocationList = response.data.data;
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getConstituency() {
      axios({
        url: "/constituency/assembly/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
          // constituencyId: this.constFilter,

        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.appLoading = false;
          this.LocationList = response.data.data;
          this.Pagelength = Math.ceil(response.data.count / 50);
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    AddConstituency() {
      this.appLoading = true;
      axios({
        url: "/constituency/assembly/add",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.newConstituency,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.addConstituencyDialog = false;
          this.newConstituency = "";
          this.appLoading = false;
          this.showsnackbar = true;
          this.msg = response.data.msg;
          this.$router.push('/addConstituency');
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    AddPanchayat() {
      this.appLoading = true;
      axios({
        url: "/add/panchayat",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.newPanchayat,
          constituencyId: this.constituency,
        },
      }) 
        .then((response) => {
          if (response.data.status == true) {
          this.addPanchayatDialog = false;
          this.msg = response.data.msg;
          this.newPanchayat = "";
          this.constituency = "",
          this.appLoading = false;
          this.$router.push('/addPanchayat');
          // this.getPanchayat();
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    AddWard() {
      this.appLoading = true;
      axios({
        url: "/add/ward",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.newWard,
          panchayatId: this.panchayat,

        },
      })
        .then((response) => {
          if (response.data.status == true) {
          this.showSnackBar = true;
          this.addWardDialog = false;
          this.msg = response.data.msg;
          this.newWard = "";
          this.panchayat = "";
          this.appLoading = false;
          this.$router.push('/addWard');
          // this.getWard();
        } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    Addbooth() {
      this.appLoading = true;
      axios({
        url: "/add/booth",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.newbooth,
          constituencyId: this.constituency,
          panchayatId: this.panchayat,
          wardId: this.Newward,
        },
      })
        .then((response) => {
          this.showSnackBar = true;
          this.addBoothDialog = false;
          this.msg = response.data.msg;
          this.newbooth = "";
          this.constituency = "";
          this.panchayat = "";
          this.Newward = "",
          this.appLoading = false;
          this.$router.push('/addBooth');
          // this.getbooth();   
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    },
};
</script>
<style scoped>
.bluegrad{
  background: rgb(24,36,68);
background: linear-gradient(36deg, rgba(24,36,68,1) 3%, rgba(0,85,135,1) 52%, rgba(0,99,161,1) 95%);
}
</style>
